// API layer - re-exports from static data
export type { Article, Case, Agent, Category } from '@/lib/types';

export {
  getMainCategories,
  getSubCategories,
  getCategoryBySlug,
  getArticles,
  getHotArticles,
  getArticleById,
  getCases as getCasesList,
  getHotCases,
  getCaseById,
  getAgents,
  getHotAgents,
  getAgentById,
  incrementAgentUseCount,
} from '@/lib/static-data';

// Client-side wrappers
import type { Article, Case, Agent } from '@/lib/types';
import { getArticles, getCases as getCasesList, getAgents as fetchAgentsList } from '@/lib/static-data';

export async function getAllArticles(): Promise<Article[]> {
  const { articles } = await getArticles({ status: 'published', limit: 200 });
  return articles;
}

export async function getCases(): Promise<Case[]> {
  const { cases } = await getCasesList({ status: 'published', limit: 100 });
  return cases;
}

export async function fetchAgents(): Promise<Agent[]> {
  const { agents } = await fetchAgentsList({ status: 'published', limit: 100 });
  return agents;
}

export async function getArticlesByCategory(categoryId: string): Promise<Article[]> {
  const { articles } = await getArticles({ categoryId, status: 'published', limit: 100 });
  return articles;
}
